import type IMapProperty from '../private/IMapProperty';

const MAPPINGS: IMapProperty[] = [
    {
        localName: 'id',

        defaultValue: 0,
    },
    {
        localName: 'name',

        defaultValue: '',
    },
    {
        localName: 'imageFileName',

        defaultValue: '',
    },
    {
        localName: 'removeImage',

        defaultValue: false,
    },
    {
        localName: 'imageMediumId',

        defaultValue: '',
    },
    {
        localName: 'siteId',

        defaultValue: 0,
    },
    {
        localName: 'languageId',

        defaultValue: 0,
    },
    {
        localName: 'floorPlanId',

        defaultValue: 0,
    },
    {
        localName: 'positionX',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'positionY',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'zoom',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'siteObjectsOnFloorPlanCount',

        defaultValue: 0,
    },
    {
        localName: 'styleId',

        defaultValue: 0,
    },
];

export default MAPPINGS;
